<template>
<div class="page-points-order container">
    <div class="points-order-tabs">
        <pi-tabs :list="tabsList" :active="tabs" type="border" @change="tabsClick"></pi-tabs>
    </div>
    <van-list class="container-flex bg" v-model="loading"
                :finished="isAll"
                finished-text="没有更多了"
                @load="scrollToLower">
        <div class="points-order-item" @click="goDetails(item)" :key="index" v-for="(item,index) in orderList">
            <div class="order-name-box">
                <div class="order-name">{{item.goodsList[0].goodsName}}</div>
                <div class="order-status">{{item.orderStatusDesc}}</div>
            </div>
            <pi-order-item-data :goodsData="item.goodsList[0]" type="orderList"></pi-order-item-data>
        </div>
    </van-list>
</div>
</template>

<script>
import { getMallorderPage } from "../../common/api/index";
import piOrderItemData from "@/components/pi-order-item-data/pi-order-item-data";
import piTabs from "@/components/pi-tabs/pi-tabs";
import { List } from "vant";
export default {
  name: "points-goods-details",
  components: {
    [piOrderItemData.name]: piOrderItemData,
    [List.name]: List,
    [piTabs.name]: piTabs,
  },
  data() {
    return {
      tabsList: [
        {name: '全部',value : '0'},
        {name: '待发货',value : '10'},
        {name: '待收货',value : '20'},
        {name: '已完成',value : '30'},
      ],
      tabs: '0',
      isAll: false,
      globalPageIndex: 1,
      orderList: [],
      from: {
        orderStatus: '',
        globalPageIndex: 1,
        globalPageSize: 10,
      },
      loading: false
    };
  },
  methods: {
    tabsClick(item){
      this.from.orderStatus = item.value == '0' ? '' : item.value;
      this.from.globalPageIndex = 1;
      this.tabs = item.value;
      this.isAll = false;
      this.orderList = [];
      this.getMallorderPage();
    },
    scrollToLower(){
        this.from.globalPageIndex = this.globalPageIndex + 1;
        this.getMallorderPage();
    },
    goDetails(item){
       this.$router.push("points-order-details?orderNo=" + item.orderNo);
    },
    async getMallorderPage(){
      this.loading = true;
      let ret = await getMallorderPage(this.from);
      if (ret.status === 0) {
        this.orderList.push(...ret.data);
        if(this.orderList.length >= ret.total){
          this.isAll = true;
        }
      }else{
        this.$toast(ret.msg)
      }
      this.loading = false;
    },
  },
  mounted() {
    this.getMallorderPage();
  },
};
</script>

<style lang="less">
@import "../../assets/less/old/var.less";
.page-points-order{


  .points-order-tabs{
      background-color: #fff;
  }
  .points-order-item{
      margin-top: 0.10rem;
      font-size: 0.28rem;
      line-height: 0.40rem;
      color: #666;
      background-color: #fff;
  }
  .order-name-box{
      padding: 0.20rem;
    display: flex;
  }
  .order-name{
      color: #000000;
      flex: 1;
  }
  .order-status{
      color: #999;
      font-size: 0.24rem;
      line-height: 0.33rem;
      margin-top: 0.04rem;
  }
  .order-goods-info{
      display: flex;
      padding: 0.20rem;
      border-top: 1px solid #F5F4F9;
  }
  .order-goods-img-box{
      width: 1.60rem;
  }
  .order-goods-img-box .order-goods-img{
      height: 1.41rem;
      width: 100%;
  }
  .order-info{
      flex: 1;
      text-align: right;
  }
  .order-info-text{
      margin-top: 0.10rem;
  }
  .order-info-text:first-child{
      margin-top: 0;
  }
  .order-info-text .total{
      color: #000000;
  }
}
</style>
